import { StoreData } from "./store.data";
import { CurrencyType } from "../types/location-currency.types";
import { SavingGoalTrackingMethod } from "../types/saving-goal.types";

export type SavingGoalModelVersion = 0;

/** Represents the store model for a saving goal (gloss-client #4723). */
export interface SavingGoalStoreModel extends StoreData {
  /**  **Version Number** **/
  v: SavingGoalModelVersion;

  nm: string; // name
  ta: number; // targetAmount
  cur?: CurrencyType | null; // currency
  sdt: Date; // startDate
  tdt?: Date | null; // targetDate
  acId: string; // accountId — the single tracked account (no multi-source support yet)
  trm: SavingGoalTrackingMethod; // trackingMethod
  bhb?: number | null; // baselineToHoldBack — set when trm === "growthAboveBaseline"
  pob?: number | null; // percentageOfBalance — set when trm === "percentageOfBalance"
}

/** Default values for the saving goal store model */
export const DefaultSavingGoalStoreModel: SavingGoalStoreModel = {
  v: 0,
  nm: "",
  ta: 0,
  cur: null,
  sdt: null,
  tdt: null,
  acId: "",
  trm: "growthAboveBaseline",
  bhb: null,
  pob: null,
  id: "",
  dc: "",
  dm: "",
  vid: "",
};
